import {h, Fragment} from "preact"
import SearchResultsPanel from "./SearchResultsPanel"
import { settings } from "../config"
import { useSearchQuery } from "../hooks"

export default function History() {
    const {searchQuery} = useSearchQuery(true);

    const defaultProducts = (settings?.search_product_list || [])?.slice(0, 4);

    return !searchQuery ? (
        <SearchResultsPanel 
            products={defaultProducts} 
            searchQuery={searchQuery} />
    ) : null;
}
